import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core'
import { SharedService } from '../../../@core/services/shared.service'
import { NbDialogRef } from '@nebular/theme'
import { EInfoFormType, IInfoForm, InfoFormService } from '../../../@core/services/info-form.service'
import { Subscription } from 'rxjs'
import { SocketService } from '../../../@core/services/socket.service'
import { differenceInMinutes, differenceInSeconds, format, parseISO, subMinutes } from 'date-fns'

@Component({
    templateUrl: './request-information.component.html',
    styleUrls: ['./request-information.component.scss'],
    selector: 'app-request-information',
})
export class RequestInformationComponent implements OnInit, OnDestroy, AfterViewInit {
    constructor(
        public sharedService: SharedService,
        public infoFormService: InfoFormService,
        private socket: SocketService,
        private dialogRef: NbDialogRef<any>
    ) {}
    dataSource: Array<IInfoForm>
    TYPE = EInfoFormType
    infoFormUpdatedSub: Subscription
    ngAfterViewInit() {}
    ngOnInit() {
        this.showData()
        this.infoFormUpdatedSub = this.socket.on('info-form-updated').subscribe((data: IInfoForm) => {
            console.log(`Socket IO: info-form-updated`, data)
            this.showData()
        })
    }
    showData() {
        this.infoFormService.getList({ page: 1, limit: 3, orderBy: 'id|desc' }).subscribe((res) => {
            this.dataSource = res.data.map((e: IInfoForm, index) => {
                let type = ''
                switch (e.type) {
                    case EInfoFormType.CUSTOMER_INFO: {
                        type = 'Customer'
                        break
                    }
                    case EInfoFormType.APPOINTMENT_INFO: {
                        type = 'Appointment'
                        break
                    }
                    case EInfoFormType.SELL_GIFT_CARD_INFO: {
                        type = 'Sell gift card'
                        break
                    }
                    default: {
                        type = e.type
                    }
                }
                //
                let status = ''
                if (e.skippedAt) {
                    status = 'skipped'
                } else if (e.respondedAt) {
                    status = 'responded'
                } else {
                    status = 'no response'
                    if (index === 0 && differenceInSeconds(new Date(), parseISO(e.createdAt)) <= 180) {
                        status = 'waiting for response'
                    }
                }
                let formattedTime = null
                if (e.timeInString) {
                    const options = { timeStyle: 'short', hour12: true }
                    formattedTime = parseISO(
                        format(new Date(), 'yyyy-MM-dd') + ' ' + e.timeInString
                    ).toLocaleTimeString('en-US', options)
                }

                return {
                    ...e,
                    typeDisplay: type,
                    status: status,
                    formattedDate: e.dateInString ? format(parseISO(e.dateInString), 'EE, MMM dd, yyyy') : null,
                    formattedTime: formattedTime,
                }
            })
        })
    }
    onCancel() {
        this.dialogRef.close()
    }
    onCustomerInfoClick() {
        this.infoFormService.create({ type: EInfoFormType.CUSTOMER_INFO }).subscribe((r) => {
            this.showData()
        })
    }
    onAppointmentInfoClick() {
        this.infoFormService.create({ type: EInfoFormType.APPOINTMENT_INFO }).subscribe((r) => {
            this.showData()
        })
    }

    ngOnDestroy(): void {
        this.infoFormUpdatedSub?.unsubscribe()
    }
}
